import ProjectMaintenanceCard from "@/components/common/ProjectMaintenanceCard";
import { PROJECT_MAINTENANCE_DATA } from "const/services/it-consulting-services";

const ProjectMaintenance = () => {
  return (
    <div className="bg-primary-black py-16 md:px-8 xl:px-10">
      <div className="flex flex-col xl:flex-row justify-between py-16 md:pb-4 xl:pb-8 px-4 md:px-0">
        <h2 className="text-4xl md:text-6xl f md:leading-snug font-medium text-white mb-2">
          <span>
            Project Assistance <br />
            and Maintenance
          </span>
        </h2>
        <p className="text-base font-normal text-white w-full xl:w-1/2 text-justify">
          <span>
            It is always possible that you might be stuck with the project
            development team or you need a reliable development partner who can
            take care of your product maintenance. ultroNeous team carries the
            expertise to take care of the projects which are stuck with teams
            due to technical competency or not having bandwidth to launch the
            project on time. Our expert developers are skilled to take over the
            ongoing projects development, and complete the features developments
            within a defined set of time. Also, they are trained to take the
            annual maintenance contract (AMC) of your website, mobile
            applications and server with a clear scope of work.
          </span>
        </p>
      </div>
      <div className="pt-4 px-4 pb-16 md:py-20 md:px-0 xl:p-20">
        {PROJECT_MAINTENANCE_DATA.map((values, index) => (
          <ProjectMaintenanceCard
            key={values.leftText}
            {...{ ...values, index, length: PROJECT_MAINTENANCE_DATA.length }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectMaintenance;
